/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular
    .module('prism-ui.components.branding')
    .factory('BrandingMediaViewDataTransformer', (
        uiGridConstants: JS5Object
    ) => {
        return {
            prePostRolls: [
                {
                    field: 'acceptProfile.name',
                    displayName: 'Media Accept Profile',
                    width: '*',
                    sort: {
                        direction: uiGridConstants.ASC,
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }, {
                    field: 'virtualPath',
                    displayName: 'Video File',
                    width: '*',
                    cellTemplate: 'components/branding/editView/components/searchGrid/cellTemplates/asset-info-cell-template.html'
                }, {
                    field: 'numberOfAudios',
                    displayName: '# Audios',
                    width: '100',
                    type: 'number',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }, {
                    field: 'numberOfTexts',
                    displayName: '# CC',
                    width: '100',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ],

            breakPrePostRolls: [
                {
                    field: 'acceptProfile.name',
                    displayName: 'Media Accept Profile',
                    width: '*',
                    sort: {
                        direction: uiGridConstants.ASC,
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }, {
                    field: 'preRoll.virtualPath',
                    displayName: 'PreRoll Video File',
                    width: '25%',
                    cellTemplate: 'components/branding/editView/components/searchGrid/cellTemplates/asset-info-cell-template.html'
                }, {
                    field: 'postRoll.virtualPath',
                    displayName: 'PostRoll Video File',
                    width: '25%',
                    cellTemplate: 'components/branding/editView/components/searchGrid/cellTemplates/asset-info-cell-template.html'
                }, {
                    name: 'numberOfAudios',
                    preRollField: 'numberOfBreakPreRollAudios',
                    postRollField: 'numberOfBreakPostRollAudios',
                    displayName: '# Audios',
                    width: '100',
                    cellTemplate: 'components/branding/editView/components/searchGrid/cellTemplates/break-prepostroll-cell-template.html'
                }, {
                    name: 'numberOfTexts',
                    preRollField: 'numberOfBreakPreRollTexts',
                    postRollField: 'numberOfBreakPostRollTexts',
                    displayName: '# CC',
                    width: '100',
                    cellTemplate: 'components/branding/editView/components/searchGrid/cellTemplates/break-prepostroll-cell-template.html'
                }
            ],

            watermarks: [
                {
                    field: 'videoAcceptProfile.name',
                    displayName: 'Media Accept Profile',
                    width: '*',
                    sort: {
                        direction: uiGridConstants.ASC,
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }, {
                    field: 'virtualPath',
                    displayName: 'Watermark File',
                    width: '*',
                    cellTemplate: 'components/branding/editView/components/searchGrid/cellTemplates/asset-info-cell-template.html'
                }
            ],

            artwork: [
                {
                    field: 'acceptProfile.name',
                    displayName: 'Media Accept Profile',
                    width: '*',
                    sort: {
                        direction: uiGridConstants.ASC,
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }, {
                    field: 'numberOfAssets',
                    displayName: '# Artwork',
                    width: '100',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ],

            ratingOverlays: [
                {
                    field: 'mediaAcceptProfile.name',
                    displayName: 'Media Accept Profile',
                    width: '*',
                    sort: {
                        direction: uiGridConstants.ASC,
                    },
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }, {
                    field: 'numberOfAssets',
                    displayName: '# Images',
                    width: '100',
                    cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
                }
            ]
        };
    });
